"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _nestedMenuItemsFromObject = require("./nestedMenuItemsFromObject");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ContextMenu = function ContextMenu(_ref) {
  var children = _ref.children,
      menuItemsData = _ref.menuItemsData;

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      menuPosition = _React$useState2[0],
      setMenuPosition = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      mouseDownPosition = _React$useState4[0],
      setMouseDownPosition = _React$useState4[1];

  var handleItemClick = function handleItemClick(event) {
    setMenuPosition(null);
  };

  var handleMouseDown = function handleMouseDown(event) {
    if (menuPosition !== null) {
      setMenuPosition(null);
    }

    if (event.button !== 2) return;
    setMouseDownPosition({
      top: event.clientY,
      left: event.clientX
    });
  };

  var handleMouseUp = function handleMouseUp(event) {
    var top = event.clientY;
    var left = event.clientX;
    if (mouseDownPosition === null) return;

    if (mouseDownPosition.top === top && mouseDownPosition.left === left) {
      setMenuPosition({
        top: event.clientY,
        left: event.clientX
      });
    }
  };

  var menuItems = (0, _nestedMenuItemsFromObject.nestedMenuItemsFromObject)({
    items: menuItemsData,
    isOpen: !!menuPosition,
    handleClose: handleItemClick
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp
  }, /*#__PURE__*/_react["default"].createElement(_material.Menu, {
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    open: !!menuPosition,
    onClose: function onClose() {
      return setMenuPosition(null);
    },
    anchorReference: "anchorPosition",
    anchorPosition: menuPosition
  }, menuItems), children);
};

exports.ContextMenu = ContextMenu;